export enum RoleName {
  Client = 'Client',
  Practitioner = 'Practitioner',
  Curator = 'Curator',
  Admin = 'Admin',
  CuratorAdmin = 'CuratorAdmin',
  Marketing = 'MarketingAdmin',
  User = 'User',
  AccountAdmin = 'AccountAdmin',
  Patient = 'Patient',
  SysAdmin = 'SysAdmin',
  OrgAdmin = 'OrgAdmin',
}
